import { useEffect, useState } from "react";
import arrowLeft from "../../Assets/icon/arrow-narrow-left.svg";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
import AddMembersModal from "../../Components/MembershipAddmemberModal";
import AnnualMembershipList from "./AnnualMembershipList";
import InvitetoAris from "../RelationshipProfile/Invitetoaris";
import ContactCard from "./ContactCard";
import CoachingMinutesModal from "../../Components/CoachingMinutesModal";
import { ReactComponent as Downarrow } from "../../Assets/icon/chevron-down-blue.svg";
import AnnualMembershipPlans from "./AnnualMembershipplans";
import TakeOwnership from "./TakeOwnership";
import {
  assignLicense,
  getUserSubscriptionDetails,
  verifySubscription,
} from "../../Services/subscription"; // Import your new API function
import { billingPortal } from "../../Services/subscription";
import { fetchPrivateInstructions } from "../../Services/coaching";
import RequestMinutes from "./RequestMinutes";
import "./style.css";
import "../ManageMembership/style.css";
import { useSearchParams } from "react-router-dom";
import Allset from "../../Components/AllsetComponent";
import { getProducts } from "../../Services/subscription";
// BuyMinutes replaced by RequestMinutes in 'buy' mode
import "../../Pages/TermsofUse/style.css";
import "../../Pages/MyProfile/style.css";
import AddRelationShipChatModal from "../RelationShip/AddRelationShipChatModal";
import AssignMembershipModal from "../../Components/AssignMembershipModal";
import LoadingScreen from "../LoadingPage/ContentLoader";

function ManageMembership() {
  const [searchParams] = useSearchParams();
  const ispurchased = searchParams.get("ispurchased");
  const showModal = searchParams.get("showModal");
  const session_id = searchParams.get("session_id");
  const method = searchParams.get("method");

  // var successmode = searchParams.get("mode");
  const navigate = useNavigate();
  const { setHeaderContent } = useHeader();
  const [isAddOpen, setisAddOpen] = useState(false);
  const [isAnnualList, setisAnnualList] = useState(showModal);
  const [isInviteOpen, setisInviteOpen] = useState(false);
  const [isCoachingMinutesOpen, setIsCoachingMinutesOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isArisAnnualMembership, setisArisAnnualMembership] = useState(false);
  const [isTakeOwnership, setisTakeOwnership] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [unAssignedLicenceData, setUnAssignedLicenceData] = useState(null);
  const [assignedLicenceData, setAssignedLicenceData] = useState(null);

  const [dialogueMinutes, setDialogueMinutes] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [Reqcoachingminutes, setsetReqcoachingminutes] = useState(false);
  // Reuse one modal for both request and buy flows
  const [requestAction, setRequestAction] = useState("request"); // 'request' | 'buy'
  const [listedMembers, setlistedMaembers] = useState(0);
  const [selectedAddonUser, setselectedAddonUser] = useState([]);
  const [currentMemberIndex, setCurrentMemberIndex] = useState(0);
  const [allMemberData, setAllMemberData] = useState([]);
  const [addMembershipLoading, setAddMembershipLoading] = useState(false);
  const [isAllSet, setAllset] = useState(
    ispurchased === "confirm" || ispurchased === "cancel" ? true : false
  );
  const [products, setProducts] = useState([]);
  const [productLoading, setproductLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);
  const [selectedValueforBuyMinutes, setselectedValueforBuyMinutes] =
    useState("");
  // Faith & Belief settings moved to Settings page
  const [showEditRelationship, setshowEditRelationship] = useState(false);
  const [selectedLicence, setselectedLicence] = useState(null);
  const [licenseAssignmentSuccessFailure, setLicenseAssignmentSuccessFailure] =
    useState(null);
  const [subscriptionVerified, setSubscriptionVerified] = useState(searchParams.get('subscriptionVerified') || null);
  const [successmode, setSuccessMode] = useState("");

  // useEffect(() => {
  //   setHeaderContent(false);
  //   fetchSubscriptionData();
  //   fetchProducts();
  //   fetchUserFaith();
  //   fetchLicenceListData();
  // }, []);

  useEffect(() => {
    setHeaderContent(false);
    setInitialLoading(true);
    Promise.allSettled([
      fetchSubscriptionData(),
      fetchProducts(),
      fetchLicenceListData(),
      fetchDialogueMinutes(),
    ])
      .then((results) => {
        results.forEach((result, index) => {
          if (result.status === "rejected") {
            console.error(`API call ${index} failed:`, result.reason);
          }
        });
      })
      .catch((error) => {
        setError("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setInitialLoading(false);
      });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("successMode")) {
      setAllset(true);
    }
  });

  useEffect(() => {
    if (licenseAssignmentSuccessFailure?.msg?.length > 0) {
      setTimeout(() => {
        setLicenseAssignmentSuccessFailure(null);
      }, 3000);
    }
  }, [licenseAssignmentSuccessFailure]);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(null);
      }, 3000);
    }
  }, [success]);

  useEffect(() => {
    const handleVerifySubscription = async () => {
      if (localStorage.getItem("schedule") === "true") {
        setSubscriptionVerified("confirm");
        localStorage.removeItem("schedule");
        return;
      } else {
        try {
          const payload = {
            checkout_session_id: session_id,
            email: JSON.parse(localStorage.getItem("profile"))?.email || "",
          };
          const response = await verifySubscription(payload);
          if (response.status === "success") {
            setSubscriptionVerified("confirm");
            setAllset(true); // open success dialog
            // refresh subscription data to reflect new membership
            await fetchSubscriptionData();
            await fetchLicenceListData();
          }
        } catch (error) {
          setSubscriptionVerified("cancel");
          setAllset(true); // open failure dialog
          console.error("Error verifying subscription:", error);
        }
      }
    };

    if (ispurchased === "confirm" && session_id) {
      handleVerifySubscription();
    } else if (ispurchased === "cancel") {
      setSubscriptionVerified("cancel");
      setAllset(true);
    }
  }, [ispurchased, session_id]);

  useEffect(() => {
    setSuccessMode(
      searchParams.get("mode")
        ? searchParams.get("mode")
        : localStorage.getItem("successMode")
    );
  }, []);

  const rearrangePlans = (products) => {
    return products.sort((a, b) => {
      const getOrder = (planType) => {
        if (planType === "main") return 1;
        if (planType === "addon") return 2;
        return 3;
      };

      const planA = a.metadata?.plan_type || "";
      const planB = b.metadata?.plan_type || "";

      return getOrder(planA) - getOrder(planB);
    });
  };

  const getbuymins = (pricemetadata) => {
    setselectedValueforBuyMinutes(pricemetadata?.metadata?.product_value);
    localStorage.setItem(
      "buyMinsSuccessMode",
      pricemetadata?.metadata?.product_value
    );
  };

  const getaddedCoachingMins = (purchasedMins) => {
    localStorage.setItem(
      "addCoachingMinsSuccessMode",
      purchasedMins?.metadata?.product_value
    );
  };

  // Removed legacy fetchUserFaith; using getUserFaith directly in the init effect.

  const fetchProducts = async () => {
    try {
      setproductLoading(true);
      const res = await getProducts();
      const resProduct = res?.payload.products
      const rawList = resProduct || []

      if (!Array.isArray(rawList) || rawList.length === 0) {
        setProducts([]);
        return;
      }

      // Build pricingDetails directly from product payload
      const mapped = rawList.map((product) => {
        const pricingDetails = [];

        // Recurring intervals from price_plans.intervals
        const intervals = product?.price_plans?.intervals || [];
        intervals.forEach((iv) => {
          pricingDetails.push({
            id: iv?.stripe_price_id,
            unit_amount: iv?.unit_amount,
            recurring: { interval: iv?.interval },
            nickname: iv?.nickname,
            price_type: iv?.price_type, // 'recurring'
            metadata: {
              price_type:
                product?.plan_type === "primary" || product?.metadata?.plan_type === "main"
                  ? "primary-users"
                  : product?.plan_type,
            },
          });
        });

        // Additional recurring prices from metadata.stripe_prices (e.g., addon_users)
        const stripePrices = product?.metadata?.stripe_prices || {};
        Object.values(stripePrices).forEach((sp) => {
          pricingDetails.push({
            id: sp?.stripe_price_id,
            unit_amount: sp?.unit_amount,
            recurring: sp?.interval ? { interval: sp?.interval } : undefined,
            nickname: sp?.nickname,
            price_type: sp?.price_type,
            metadata: {
              price_type: sp?.nickname === "addon_users" ? "sub-users" : sp?.price_type,
              product_type: sp?.nickname,
            },
          });
        });

        // One-time prices (e.g., Coaching Minutes) from prices
        const oneTimes = product?.prices || [];
        oneTimes.forEach((ot) => {
          // Try to parse minutes from nickname like "60_min_coaching"
          let minutes = undefined;
          if (typeof ot?.nickname === 'string') {
            const match = ot.nickname.match(/(\d+)/);
            if (match) minutes = parseInt(match[1], 10);
          }
          pricingDetails.push({
            id: ot?.stripe_price_id,
            unit_amount: ot?.unit_amount,
            recurring: ot?.interval ? { interval: ot?.interval } : undefined,
            nickname: ot?.nickname,
            price_type: ot?.price_type || "one_time",
            metadata: {
              price_type: ot?.price_type || "one_time",
              product_value: minutes, // minutes for display
              price_value: ot?.unit_amount, // in cents
            },
          });
        });

        return { ...product, pricingDetails };
      });

      setProducts(rearrangePlans(mapped));
    } catch (err) {
      console.error(err, "product error");
      const msg = err?.response?.data?.message || err?.message || "Something went wrong. Please try again later.";
      setError(msg);
    } finally {
      setproductLoading(false);
    }
  };

  const fetchDialogueMinutes = async () => {
    try {
      const res = await fetchPrivateInstructions();
      const seconds = res?.payload?.minutes;
      if (typeof seconds === "number") {
        const mins = Math.floor(seconds / 60);
        setDialogueMinutes(mins);
      } else {
        setDialogueMinutes(null);
      }
    } catch (err) {
      console.error("Failed to fetch private instructions:", err);
      setDialogueMinutes(null);
    }
  };

  // Faith product details removed from ManageMembership

  const handleAllsetClose = () => {
    localStorage.removeItem("successMode");
    localStorage.removeItem("buyMinsSuccessMode");
    localStorage.removeItem("addCoachingMinsSuccessMode");
    localStorage.removeItem("transfermins");
    localStorage.removeItem("buyMins");

    navigate("/manageMembership", { replace: true });
    setAllset(false);
    // Reload after closing the success modal so labels/options reflect the latest state
    window.location.reload();
  };

  const fetchSubscriptionData = async () => {
    try {
      setLoading(true);
      const response = await getUserSubscriptionDetails();
      // Handle new response format - check payload first, then fallback to direct response
      const data = response?.payload || response;
      // Normalize new v2 list response: { subscriptions: [...], total, page, limit }
      let normalized = null;
      let profile = JSON.parse(localStorage.getItem("profile") || "{}");
      if (Array.isArray(data?.subscriptions)) {
        const sub = data.subscriptions[0];
        if (sub) {
          if (profile?.user_type !== "primary") {
            profile = data.payee_details
            profile.user_type = "sub-user"
          }
          const billingCycle = sub.billing_cycle; // 'monthly' | 'yearly'
          const membership_type =
            billingCycle === "monthly" ? "month" : billingCycle === "yearly" ? "year" : billingCycle;
          // Determine FAITH access
          const hasFaithAccess = Array.isArray(sub?.functionality_access)
            ? sub.functionality_access.some((f) => f?.func_code === "FAITH" && f?.status === "active")
            : false;
          // Sum remaining minutes from minute_packages
          const totalRemainingMinutes = (sub?.minute_packages || []).reduce(
            (sum, p) => sum + (p?.remaining_minutes || 0),
            0
          );
          normalized = {
            // compatibility fields expected by UI
            membership_type,
            renewal_data: sub.next_billing_date || sub.current_period_end,
            cancel_at_period_end: sub?.cancel_at_period_end === true,
            total_amount: typeof sub.next_billing_amount === "number" ? sub.next_billing_amount / 100 : undefined,
            user_type: profile?.user_type || undefined,
            sub_users_present: false,
            sub_user_data: [],
            // Map minute packages to addon items for "Your Add-Ons" list
            addon_packs: (sub?.minute_packages || []).map((p) => ({
              product_name: "Coaching Minutes",
              quantity: 1,
              product_value: p?.total_minutes ?? p?.remaining_minutes ?? 0,
            })),
            coaching_minutes: totalRemainingMinutes,
            license_summary: sub?.license_summary || null,
            has_faith_access: hasFaithAccess,
            payee_details: {
              first_name: profile?.first_name || "",
              last_name: profile?.last_name || "",
              profile_url: profile?.profile_pic || "",
            },
            subscription_id: sub?.subscription_id || sub?.id,
            subscription_data: {
              plan_details: {
                marketing_features: sub?.plan?.features || [],
                metadata: sub?.plan?.metadata || {},
              },
            },
          };

          // Derive unassigned and assigned license data from license_assignments
          const licenseAssignments = Array.isArray(sub?.license_assignments)
            ? sub.license_assignments
            : [];
          const pendingLicences = licenseAssignments.filter((a) => a?.status === "pending");
          const mappedLicences = pendingLicences.map((a) => ({
            license_id: a?.assignment_id,
            user_id: a?.assigned_user_id,
            first_name: "Assign",
            last_name: "Licenses",
            profile_pic: "",
            addon_packs: [],
            contact: "",
            email: a?.invited_email || "No Email Provided",
            coaching_minutes: { value: 0 },
            faith_present: false,
            faith_value: "",
          }));
          setUnAssignedLicenceData(mappedLicences);

          // Active (assigned) licenses
          const activeLicences = licenseAssignments.filter((a) => a?.status === "active");
          const mappedActive = activeLicences.map((a) => ({
            license_id: a?.assignment_id,
            user_id: a?.assigned_user_id,
            first_name: a?.first_name || "Assigned",
            last_name: a?.last_name || "User",
            profile_pic: a?.profile_pic || "",
            addon_packs: [],
            contact: "",
            email: a?.email || a?.invited_email || "",
            coaching_minutes: { value: a?.seconds_left/60 || 0 },
            faith_present: false,
            faith_value: "",
          }));
          setAssignedLicenceData(mappedActive);
        }
      }

      // Legacy format fallback where payload already matches UI expectations
      if (!normalized) {
        normalized = response?.payload || null;
      }

      setSubscriptionData(normalized);
      setLoading(false);
    } catch (error) {
      setError(
        error?.response?.data?.message || "Failed to load subscription details"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchLicenceListData = async () => {
    // No-op: Licenses now come from subscription. Left here for compatibility with existing calls.
    return;
  };

  const handleContactClick = (license) => {
    setSelectedContact(license);
    setIsCoachingMinutesOpen(true);
  };

  const contact = [
    {
      _id: "1",
      first_name: "John",
      last_name: "Doe",
      profile_pic_url: "",
      related_data: {
        relationship_category: "Family",
      },
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const memberContIncrement = (t) => {
    setlistedMaembers(t);
  };

  const handleInviteSubmit = (data) => {
    // Collect data from all members in an array
    setAllMemberData((prevData) => [...prevData, data]);
  };

  const handleMemberComplete = () => {
    const nextIndex = currentMemberIndex + 1;
    setCurrentMemberIndex(nextIndex);

    if (nextIndex >= listedMembers) {
      // All members have been invited
      setisInviteOpen(false);
      // Reset for next time
      setCurrentMemberIndex(0);
      setAllMemberData([]);
      // Optionally show a success message or fetch updated data
      fetchSubscriptionData();
    }
  };

  const onEmailPhoneSubmit = (e) => {
    setselectedAddonUser(e);
  };

  const openAddMembersModal = () => {
    setCurrentMemberIndex(0);
    setAllMemberData([]);
    setisAddOpen(true);
  };

  const handleAddMembershipsClick = async () => {
    try {
      setAddMembershipLoading(true);
      const origin = window.location.origin;
      const subscriptionId = subscriptionData?.subscription_id || subscriptionData?.id;
      if (!subscriptionId) {
        throw new Error("Missing subscription id to open billing portal.");
      }
      if (!primaryPriceId) {
        throw new Error("Missing price id to open billing portal.");
      }

      const payload = {
        return_url: `${origin}/manageMembership`,
        payload: {
          subscription_id: subscriptionId,
          allowed_price_ids: [primaryPriceId],
          disable_cancellation: true,
        },
      };

      const res = await billingPortal(payload);
      const url = res?.url || res?.payload?.url;
      if (url) {
        window.location.href = url;
        return;
      }
      throw new Error("No billing portal URL returned");
    } catch (error) {
      console.error("Error opening billing portal:", error);
      setError(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to open billing portal. Please try again later."
      );
    } finally {
      setAddMembershipLoading(false);
    }
  };

  const onTransferMinutesComplete = () => {
    setIsCoachingMinutesOpen(false);
    setSuccessMode("transfer");
    setAllset(true);
    setSubscriptionVerified("confirm");
  };

  // Find add-on user price
  const normalizeInterval = (i) => {
    if (i === "monthly") return "month";
    if (i === "yearly") return "year";
    return i;
  };
  const targetInterval = normalizeInterval(subscriptionData?.membership_type);
  let addonUnitAmountCents;
  let primaryPriceId;
  let primaryUnitAmountCents;
  if (Array.isArray(products)) {
    for (const p of products) {
      const list = Array.isArray(p?.pricingDetails) ? p.pricingDetails : [];
      for (const price of list) {
        const nick = price?.nickname || price?.metadata?.nickname;
        const type = price?.metadata?.product_type;
        const interval = normalizeInterval(price?.recurring?.interval);
        if ((nick === 'addon_users' || type === 'addon_users') && interval === targetInterval) {
          addonUnitAmountCents = price?.unit_amount;
          break;
        }
      }
      if (addonUnitAmountCents != null) break;
    }

    // Fallback: use main plan price if addon price not found
    if (addonUnitAmountCents == null) {
      for (const p of products) {
        const isMain = p?.metadata?.plan_type === 'main' || p?.metadata?.plan_type === 'primary' || p?.name === 'Aris, your AI life coach';
        if (!isMain) continue;
        const list = Array.isArray(p?.pricingDetails) ? p.pricingDetails : [];
        for (const price of list) {
          const interval = normalizeInterval(price?.recurring?.interval);
          if (interval === targetInterval) {
            addonUnitAmountCents = price?.unit_amount;
            primaryPriceId = price?.id; // capture primary plan price id
            primaryUnitAmountCents = price?.unit_amount;
            break;
          }
        }
        if (addonUnitAmountCents != null) break;
      }
    }
  }
  // If not set yet, try to capture primaryPriceId explicitly
  if (!primaryPriceId && Array.isArray(products)) {
    const main = products.find(p => p?.metadata?.plan_type === 'main' || p?.metadata?.plan_type === 'primary' || p?.name === 'Aris, your AI life coach');
    const match = main?.pricingDetails?.find(pr => normalizeInterval(pr?.recurring?.interval) === targetInterval);
    primaryPriceId = match?.id;
    primaryUnitAmountCents = match?.unit_amount ?? primaryUnitAmountCents;
  }
  const addonPriceAmount = typeof addonUnitAmountCents === 'number' ? addonUnitAmountCents / 100 : undefined;
  const primaryPriceAmount = typeof primaryUnitAmountCents === 'number' ? primaryUnitAmountCents / 100 : undefined;

  // Faith toggle moved to Settings
  const onAddRealtionClose = () => {
    setshowEditRelationship(false);
  };

  const onAddedRelationShip = (data) => {
    // onEnterData(data);

    setLicenseAssignmentSuccessFailure({
      status: "Success",
      msg: "License assigned sucessfully",
    });
    fetchSubscriptionData();
    fetchLicenceListData();
    setshowEditRelationship(false);
  };

  const isReqMinSuccess = () => {
    setsetReqcoachingminutes(false);
    setAllset(true);
  };

  const onLicenseSelection = (licence) => {
    let id = [
      licence?.license_id,
      ...licence?.addon_packs?.map((a) => a?.license_id),
    ];
    setshowEditRelationship(true);
    setselectedLicence(id);
  };

  const onBackClick = () => {
    if (method === "update") {
      navigate("/manageMembership");
    } else navigate("/dashboard");
  };

  // Build subText for the Allset modal to avoid complex nested ternaries in JSX
  const allsetSubText = (() => {
    // Friendly message on Stripe cancel/back flow
    if (session_id && subscriptionVerified !== "confirm") {
      return "You returned from checkout. No changes were made to your membership.";
    }
    if (successmode === "transfer") {
      try {
        const t = JSON.parse(localStorage.getItem("transfermins") || "null");
        const mins = t?.transferred_minutes || 0;
        const contact = t?.contactDetails || "selected contact";
        return `${mins} minutes have been transfered to ${contact}`;
      } catch (_) {
        return "Minutes have been transferred.";
      }
    }
    if (successmode === "transferOwnership" && subscriptionVerified === "confirm") {
      return "Ownership has been transferred successfully";
    }
    if (successmode === "cancelMembership") {
      return "Membership has been cancelled successfully";
    }
    if (ispurchased === "confirm" && subscriptionVerified === "confirm") {
      if (successmode === "reqMins") return "The Primary account holder will receive your request";
      if (successmode === "buyMinutes") {
        const v = localStorage.getItem("buyMins") || "";
        return `${v} minutes were added to your account.`;
      }
      if (successmode === "addLicensedUser") return "Licensed user added successfully";
      if (successmode === "faith") return "Faith added successfully";
      if (successmode === "addMinutes") {
        const v = localStorage.getItem("addCoachingMinsSuccessMode") || "";
        return `${v} minutes were added to your account.`;
      }
    }
    return "Your subscription has been updated.";
  })();

  return (
    <div>
      <header className="termsofuse-header">
        <div className="termsofuse-gradient-background ">
          <div className="termsofuse-nav-container">
            <div className="termsofuse-logo-container " onClick={onBackClick}>
              <img
                src={arrowLeft}
                alt="Back"
                className="termsofuse-back-button"
              />
            </div>
            <h1 className="head-not-txt">Manage Membership</h1>
            <div className="termsofuse-space"></div>
          </div>

          {initialLoading || loading || productLoading ? (
            <div className="manage-loading-container">
              <LoadingScreen />
            </div>
          ) : (
            <div className="Managemanage-wrapper">
              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">{success}</div>}

              <div className="Managemembership-container">
                {/* Current Plan Section */}
                <div className="Annual-membership">
                  <div className="current-plan">Your current plan</div>
                  <div className="Arismembership-button-container">
                    <div>
                      <div className="membership-aris">Aris</div>
                      <div className="annual-membership-validity-container">
                        <div className="membership-arist2">
                          {subscriptionData?.membership_type === "month"
                            ? "Monthly membership"
                            : "Annual membership"}
                        </div>
                        <div className="annual-membership-validity">
                          {subscriptionData?.cancel_at_period_end
                            ? (
                              <>Your subscription will cancel on {formatDate(subscriptionData?.renewal_data)}</>
                            )
                            : (
                              <>Your plan will renew on {formatDate(subscriptionData?.renewal_data)}</>
                            )
                          }
                        </div>
                      </div>
                    </div>

                    <div className="membership-btn-container">
                      <button
                        className="switchpayment-btn"
                        onClick={() => setisArisAnnualMembership(true)}
                      >
                        Show details
                      </button>
                      {subscriptionData?.user_type !== "sub-user" &&
                        <button
                          className="purchase-additonal-btn"
                          onClick={() => setisAnnualList(true)}
                        >
                          Manage Plan
                        </button>
                      }
                    </div>
                  </div>
                </div>

                {/* Add Aris Dialogue Minutes Section */}
                <div className="Annual-membership">
                  <div className="Additional-membership">
                    <div className="Additonal-membership-heading-container">
                      <div className="Additonal-membership-heading">
                        Add Aris Dialogue Minutes
                      </div>
                      <div className="Additonal-membership-para-desc">
                        {dialogueMinutes !== null ? (
                          <>
                            <span className="dialogue-minutes-value">
                              {dialogueMinutes} minutes &nbsp;
                            </span>
                            left in Aris Dialogues. Add more to continue without
                            interruption.
                          </>
                        ) : (
                          "Add minutes to continue your Aris Dialogues without interruption."
                        )}
                      </div>
                    </div>
                    <div>
                      <button
                        className="membership-Add-lisence-btn"
                        onClick={() => {
                          setRequestAction("buy");
                          setsetReqcoachingminutes(true);
                        }}
                      >
                        Add Minutes
                      </button>
                    </div>
                  </div>
                </div>

                {/* Additional Members Section */
                }
                {subscriptionData?.user_type === "primary" && (
                  <div className="Annual-membership">
                    <div className="Additional-membership">
                      <div className="Additonal-membership-heading-container">
                        <div>
                          <div className="Additonal-membership-heading">
                            Additional Memberships
                          </div>
                          <div className="Additonal-membership-para">
                            {`Invite family, friends, or teammates to grow with Aris—${addonPriceAmount !== undefined
                              ? `$${addonPriceAmount.toLocaleString("en-US", {
                                minimumFractionDigits: addonPriceAmount % 1 === 0 ? 0 : 2,
                                maximumFractionDigits: 2,
                              })}`
                              : ""
                              } ${subscriptionData?.membership_type === "year" ? "/year" : "/month"} per membership.`}
                          </div>
                          {false && subscriptionData?.license_summary && (
                            <div className="Additonal-membership-para" style={{ marginTop: 6 }}>
                              <strong>Licenses:</strong>{" "}
                              Total {subscriptionData.license_summary.total_slots} | Assigned {subscriptionData.license_summary.assigned_count} | Pending {subscriptionData.license_summary.pending_count}
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <button
                          className="membership-Add-lisence-btn"
                          onClick={handleAddMembershipsClick}
                          disabled={addMembershipLoading}
                        >
                          Add Memberships
                        </button>
                      </div>
                    </div>
                    {/* Assigned memberships grid */}
                    {Array.isArray(assignedLicenceData) && assignedLicenceData.length > 0 && (
                      <>
                        <div className="Additonal-membership-heading" style={{ marginTop: 16 }}>Assigned Memberships</div>
                        <div className="manage-contacts-grid" style={{ width: "100%" }}>
                          {assignedLicenceData.map((licence) => (
                            <ContactCard
                              key={licence?.license_id}
                              contact={{
                                _id: licence.user_id,
                                first_name: licence.first_name || "Assigned",
                                last_name: licence.last_name || "User",
                                profile_pic_url: licence.profile_pic || "",
                                related_data: {
                                  relationship_category:
                                    licence?.addon_packs?.length > 0
                                      ? "Add-on pack include"
                                      : "Member",
                                },
                                contact: licence.contact || "N/A",
                                email: licence.email || "",
                                coaching_minutes: Math.floor(licence.seconds_left / 60),
                                faith_present: licence.faith_present,
                                faith_value: licence.faith_value,
                              }}
                              onClick={() => handleContactClick(licence)}
                            />
                          ))}
                        </div>
                      </>
                    )}
                    {licenseAssignmentSuccessFailure?.msg && (
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          color:
                            licenseAssignmentSuccessFailure?.status ===
                              "Failure"
                              ? "red"
                              : "green",
                        }}
                      >
                        {licenseAssignmentSuccessFailure?.msg}
                      </div>
                    )}

                    <div
                      className="manage-contacts-grid"
                      style={{ width: "100%" }}
                    >
                      {unAssignedLicenceData &&
                        Array.isArray(unAssignedLicenceData) &&
                        // Only show first 2 items if showAll is false, otherwise show all
                        unAssignedLicenceData.map((licence) => (
                          <ContactCard
                            key={licence?.license_id}
                            contact={{
                              _id: licence.user_id,
                              first_name: licence.first_name || "Assign",
                              last_name: licence.last_name || "Licenses",
                              profile_pic_url: licence.profile_pic || "",
                              related_data: {
                                relationship_category:
                                  licence?.addon_packs?.length > 0
                                    ? "Add-on pack include"
                                    : "No Add-on pack included",
                              },
                              contact: licence.contact || "N/A",
                              email: licence.email || "No Email Provided",
                              coaching_minutes:
                                licence.coaching_minutes?.value || 0,
                              faith_present: licence.faith_present,
                              faith_value: licence.faith_value,
                            }}
                            onClick={() => onLicenseSelection(licence)}
                          />
                        ))}
                      {/* Removed a dangling slice block that rendered nothing */}
                    </div>
                  </div>
                )}
                {/* Faith & Belief controls moved to Settings page */}

                {/* Primary Account Holder Section */}
                {subscriptionData?.user_type !== "primary" && (
                  <div className="Annual-membership">
                    <div className="Additional-membership">
                      <div className="Additonal-membership-heading-container">
                        <div>
                          <div className="Additonal-membership-heading">
                            Primary Account Holder
                          </div>
                          <div className="Additonal-membership-para">
                            {contact[0]?.profile_pic_url && !imageError ? (
                              <div className="manage-avatar">
                                <img
                                  src={
                                    subscriptionData?.payee_details?.profile_url
                                  }
                                  alt={`${subscriptionData?.payee_details?.first_name} ${subscriptionData?.payee_details?.last_name}`}
                                  className="manage-avatar-image"
                                  onError={() => setImageError(true)}
                                />
                              </div>
                            ) : (
                              <div className="manage-avatar">
                                {`${subscriptionData?.payee_details?.first_name?.[0]?.toUpperCase() ||
                                  ""
                                  }${subscriptionData?.payee_details?.last_name?.[0]?.toUpperCase() ||
                                  ""
                                  }` || ""}
                              </div>
                            )}
                            <div className="manage-name">
                              {`${subscriptionData?.payee_details?.first_name
                                ?.charAt(0)
                                .toUpperCase() || ""
                                }${subscriptionData?.payee_details?.first_name
                                  ?.slice(1)
                                  .toLowerCase() || ""
                                } ${subscriptionData?.payee_details?.last_name
                                  ?.charAt(0)
                                  .toUpperCase() || ""
                                }${subscriptionData?.payee_details?.last_name
                                  ?.slice(1)
                                  .toLowerCase() || ""
                                }`}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="membership-btn-container">
                        <button
                          className="membership-Add-lisence-btn"
                          onClick={() => { setRequestAction("request"); setsetReqcoachingminutes(true); }}
                        >
                          Request minutes
                        </button>

                        <button
                          className="purchase-additonal-btn"
                          onClick={() => { setRequestAction("buy"); setsetReqcoachingminutes(true); }}
                        >
                          Buy minutes
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Modals */}
        <AddMembersModal
          isAddOpen={isAddOpen}
          setisAddOpen={setisAddOpen}
          setisInviteOpen={setisInviteOpen}
          memberContIncrement={memberContIncrement}
          onStartInvites={() => setCurrentMemberIndex(0)}
          secondary_price={primaryPriceAmount}
          primary_price_id={primaryPriceId}
          subscriptionData={subscriptionData}
          setError={setError}
        />
        <AnnualMembershipList
          isAnnualList={isAnnualList}
          setisAnnualList={setisAnnualList}
          products={products}
          subscriptionData={subscriptionData}
          setError={setError}
          setAllset={setAllset}
          setSuccessMode={setSuccessMode}
          setSubscriptionVerified={setSubscriptionVerified}
          membershipType={subscriptionData?.membership_type}
          refreshSubscription={fetchSubscriptionData}
        />
        <AnnualMembershipPlans
          isArisAnnualMembership={isArisAnnualMembership}
          setisArisAnnualMembership={setisArisAnnualMembership}
          showdetails={
            subscriptionData?.subscription_data?.plan_details
              ?.marketing_features
          }
          metadata={
            subscriptionData?.subscription_data?.plan_details?.metadata
          }
          formatDate={formatDate(subscriptionData?.renewal_data)}
          addon={subscriptionData?.addon_packs}
          membership={subscriptionData?.membership_type}
          totalAmount={subscriptionData?.total_amount}
          user_type={subscriptionData?.user_type}
          membershipCount={subscriptionData?.license_summary?.total_slots}
        />
        <RequestMinutes
          Reqcoachingminutes={Reqcoachingminutes}
          setsetReqcoachingminutes={setsetReqcoachingminutes}
          priceDetails={
            products?.find(
              (product) =>
                product?.metadata?.plan_type === "addon" &&
                product?.name === "Coaching Minutes"
            )?.pricingDetails || []
          }
          isReqMinSuccess={isReqMinSuccess}
          action={requestAction}
          setError={setError}
          setisAnnualList={setisAnnualList}
        />

        {false && <div />} {/* BuyMinutes removed: unified into RequestMinutes */}
        <TakeOwnership
          isTakeOwnership={isTakeOwnership}
          setisTakeOwnership={setisTakeOwnership}
          contact={contact}
          setSubscriptionVerified={setSubscriptionVerified}
          setAllset={setAllset}
          setSuccessMode={setSuccessMode}
          membershipType={subscriptionData?.membership_type}
        />
        {showEditRelationship && (
          <AssignMembershipModal
            open={showEditRelationship}
            selectedLicence={selectedLicence}
            onClose={async ({ success }) => {
              setshowEditRelationship(false);
              if (success) {
                setLicenseAssignmentSuccessFailure({ status: "Success", msg: "Membership assigned successfully" });
                await fetchSubscriptionData();
              }
            }}
          />
        )}
        {isInviteOpen && (
          <InvitetoAris
            onClose={() => {
              setisInviteOpen(false);
              setCurrentMemberIndex(0); // Reset index when closing
              setAllMemberData([]); // Clear collected data
            }}
            relationId={1}
            name="New Member" // You can customize this if needed
            onEmailPhoneSubmit={onEmailPhoneSubmit}
            listedMembers={listedMembers}
            currentMemberIndex={currentMemberIndex}
            onMemberComplete={handleMemberComplete}
          />
        )}

        {isCoachingMinutesOpen && selectedContact && (
          <CoachingMinutesModal
            userId={selectedContact.user_id}
            licenseDetails={selectedContact}
            onClose={() => setIsCoachingMinutesOpen(false)}
            ispurchased={ispurchased}
            onTransferMinutesComplete={onTransferMinutesComplete}
            productId={
              products?.find(
                (product) =>
                  product?.metadata?.plan_type === "addon" &&
                  product?.name === "Coaching Minutes"
              )?.id
            }
            priceDetails={
              products?.find(
                (product) =>
                  product?.metadata?.plan_type === "addon" &&
                  product?.name === "Coaching Minutes"
              )?.pricingDetails
            }
            user_type={subscriptionData?.user_type}
            minutes={subscriptionData?.coaching_minutes}
            setAllset={setAllset}
            setError={setError}
            setSuccessMode={setSuccessMode}
            setSubscriptionVerified={setSubscriptionVerified}
          />
        )}
        {isAllSet && subscriptionVerified && (
          <Allset
            closeModal={handleAllsetClose}
            heading={
              // If user returned from Stripe without confirmation, show cancel message
              (session_id && subscriptionVerified !== "confirm")
                ? "Checkout canceled"
                : ((ispurchased === "confirm" ||
                  successmode === "transfer" ||
                  successmode === "transferOwnership" ||
                  successmode === "cancelMembership" ||
                  successmode === "update_billing") &&
                  subscriptionVerified === "confirm")
                  ? "You're All set"
                  : "No changes made"
            }
            subText={allsetSubText}
          />
        )}
      </header>
    </div>
  );
}

export default ManageMembership;
